import React from "react";
import { Link } from "gatsby";
import Layout from "../components/Layout";
import Footer from "../components/Footer";
import Social from "../components/Social";
import gplay from "../assets/images/google-play-badge.svg";
import astore from "../assets/images/app-store-badge.svg";

const FAQ = () => (
  <Layout>
    <section className="cta">
      <div className="cta-content">
        <div className="container">
          <h2>
            FAQ
            <br />
            <Link className="btn btn-outline btn-xl" to="/">
              Go back
            </Link>
          </h2>
        </div>
      </div>
      <div className="overlay"></div>
    </section>
    <section className="privacy" id="privacy">
      <div className="container">
        <div className="section-heading text-center">
          <h1>Samfunns-Statsborgerpøve Frequently Asked Questions</h1>
          <hr />
        </div>
        <div className="container-fluid text-muted">
          <p>
            <strong>
              <em>
                What languages does app support? <br />
                <br />
              </em>
            </strong>
            Application's interface is avaliable in Norwegian Bokmål and
            English. Questions are in Norwegian Bokmål.
          </p>{" "}
          <br />
          <p>
            <strong>
              <em>
                Is paid version one time payment or subscrition? <br />
                <br />
              </em>
            </strong>
            It is one time payment. You pay once and use forever.
          </p>
          <br />
          <p>
            <strong>
              <em>
                Do you have video overview? <br />
                <br />
              </em>
            </strong>
            Sure. you can watch video overview on Youtube &nbsp;
            <a href="https://youtu.be/j5n0uz9YK6U">
              NOR Samfunnskunnskap and Statsborgerprøve App iOS Android
              <br />
            </a>
            <br />
          </p>
          <iframe
            width="100%"
            height="400px"
            src="https://www.youtube.com/embed/j5n0uz9YK6U"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </section>
    <section className="download text-center" id="download">
      <div className="container">
        <div className="row">
          <div className="col-md-8 mx-auto">
            <div className="badges">
              <a
                className="badge-link"
                href="https://play.google.com/store/apps/details?id=com.samfunnstest.app&hl=en"
              >
                <img src={gplay} alt="google play button" />
              </a>
              <a
                className="badge-link"
                href="https://apps.apple.com/no/app/samfunnspr%C3%B8ve-citizenship-test/id1527153572#?platform=iphone"
              >
                <img src={astore} alt="app store button" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="contact" id="contact">
      <div className="container">
        <h2>
          We appreciate your feedback &nbsp;
          <i className="fas fa-heart"></i>
        </h2>
        <Social />
      </div>
    </section>

    <Footer />
  </Layout>
);

export default FAQ;
